{
    "GenericAdminFilterLanguage_CME_LABEL": "CME",
    "GenericAdminFilterLanguage_TELSYS_LABEL": "Telefonieserver",
    "GenericAdminFilterLanguage_PARTITION_LABEL": "Partition",
    "GenericAdminFilterLanguage_CRM_TYPE_LABEL": "CRM-Typ",
    "GenericAdminFilterLanguage_INCLUDE_CHILD_CMES_LABEL": "Untergeordnete CME-Elemente einschließen",
    "GenericAdminFilterLanguage_SEARCH_LABEL": "Suchen",
    "NAME": "GenericAdminFilterLanguage",
    "GenericAdminFilterLanguage_OPTION_ALL_LABEL": "Alle",
    "GenericAdminFilterLanguage_OPTION_ANY_LABEL": "Beliebig",
    "GenericAdminFilterLanguage_OPTION_NONE_LABEL": "Keiner",
    "GenericAdminFilterLanguage_PLEASE_SELECT_OPTION_TO_SHOW_RESULTS": "Bitte wählen Sie eine Option, um Ergebnisse anzuzeigen."
}